import { Row, Col, Button } from 'react-bootstrap';
import { BiSearchAlt2 } from 'react-icons/bi';
import Footer from '../../components/footer';

import { useEffect, useState } from 'react';

import { CollectionContainer } from './alpha.style';

import ApeCard from '../../components/apeCard';
import { alphaCollections, filterOptions, collectionFilterOptions } from '../../data';
import PageHeader from '../../components/pageHeader';
import HeadStats from '../../components/headerStats';
import SearchElement from '../../components/searchInput';
import ApeBtn from '../../components/button';
import OptionSelect from '../../components/selectOption';
import GridOption from '../../components/gridSelect';
import DisplayFilterOption from '../../components/filterOptionDisplay';
import DisplayApeModal from '../../components/apeDetailModal';

import alphaCollectionImg from '../../images/alphas-header.jpeg'
import leftImg from '../../images/home-left-side.svg';
import rightImg from '../../images/home-right-side.svg'

const AlphaCollection = () => {

  const { alpha } = filterOptions;

  const [selectedApe, setSelectedApe] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [filterOption, setFilterOption] = useState('lowest');
  const [searchOptions, setSearchOptions] = useState(alphaCollections);
  const [colorFilter, setColorFilter] = useState({});

  const pageLimit = 12;

  const cleanupModal = () => {
    setSelectedApe(null);
  }

  useEffect(() => {
    const options = alpha[0].options;
    let colorObj = {};
    options.forEach(option => {
      colorObj[option.name.toLocaleLowerCase()] = 0;
    })
    alphaCollections.forEach(collection => {
      colorObj[collection.color.toLocaleLowerCase()] += 1;
    })

    setColorFilter(colorObj);

  }, [alpha]);

  const handleColorFilter = (e) => {
    e.target.classList.toggle("btn-danger");
    const filter = e.target.textContent.split(' ')[0]
    const filtered = alphaCollections.filter((item) => {
      return item.color.toString().includes(filter);
    });
    setSearchOptions(filtered);
  }



  const handleSearch = (e) => {
    const search = e.target.value;
    const filtered = alphaCollections.filter((item) => {
      return item.id.toString().includes(search);
    });
    setSearchOptions(filtered);
  }


  useEffect(() => {
    const count = Math.ceil(alphaCollections.length / pageLimit);
    setPageCount(count);
  }, []);

  useEffect(() => {
    if(filterOption === 'lowest') {
      alphaCollections.sort((a, b) => b.id - a.id);
    } 
    else if(filterOption === 'highest') {
      alphaCollections.sort((a, b) => a.id - b.id);
    } 
    else if(filterOption === 'highprice') {
      alphaCollections.sort((a, b) => b.price - a.price);
    }
    else if(filterOption === 'lowprice') {
      alphaCollections.sort((a, b) => a.price - b.price);
    }

  }, [filterOption]);

  const collections = searchOptions.slice(
    (currentPage - 1) * pageLimit,
    (currentPage - 1) * pageLimit + pageLimit
    ).map((item, index) => (
      <Col className='mb-4' sm={12} md={6} lg={4} key={index}>
        <ApeCard
          handleClick={() => {
            setSelectedApe(item);
          }} 
          image={item.image} 
          name={item.name}
          id={item.id}
          likes={item.likes} />
      </Col>
    ));

  return (
    <>
    <PageHeader slide={alphaCollectionImg} />
    <HeadStats title="Alpha Collection" />

    <CollectionContainer>
      <Row>
        <Col sm={12} md={3} className="pr-3">
          <h3 className='filter'>Filters</h3>
          <div className='mb-5'>
            <ApeBtn
                handleClick={(e) => {
                  e.target.classList.toggle("btn-danger");
                  setSearchOptions(alphaCollections)
                }} 
                title={`All (${alphaCollections.length})`} />
            { Object.keys(colorFilter).map((item, index) => (
              <ApeBtn
                handleClick={handleColorFilter}
              key={index} 
              title={`${item} (${colorFilter[item]})`} />
            ))

            }
          </div> 

          { alpha.map((item, index) => (
            <DisplayFilterOption option={item} key={index} />
          ))}

        </Col>

        <Col sm={12} md={9}>
          <Row>
            <Col lg={12} xl={6} className="d-flex top-search">
              <h3 className='alpha'>Alphas(4999)</h3>
              <SearchElement
                handleChange={handleSearch}
                placeholder="Find by Serial" position >
                <BiSearchAlt2 />
              </SearchElement>

            </Col>
            <Col lg={12} xl={6} className="d-flex grid-option">
              <OptionSelect
               handleChange={(e) => setFilterOption(e.target.value)}
               options={collectionFilterOptions} />
              <GridOption />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="mt-4">
              <Row className='mt-4'>
                { collections }
              </Row>
              <Row>
                <Col sm={12} className="d-flex justify-content-end mt-4">
                  { Array.from({length: pageCount}, (_, i) => i + 1).map((_, i) => (
                     <Button key={i} onClick={() => setCurrentPage(parseInt(i+1))} style={{marginRight:".25rem"}} variant={currentPage === i+1 ? 'danger': 'light'} className="mr-2"> {i+1} </Button>
                  ))
                  }
                  <Button
                   disabled={currentPage === pageCount}
                   onClick={() => setCurrentPage(currentPage + 1)}
                   style={{marginRight:"1.4rem"}} variant="light" className="mr-2"> Next </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

      </Row>
      {
      selectedApe && 
      <DisplayApeModal
       ape={selectedApe}
       onClose={cleanupModal}
      />
      }
    </CollectionContainer>
    <Footer leftImg={leftImg} rightImg={rightImg} />

    </>
  )
}

export default AlphaCollection;